import { MutationObserverOptions, QueryObserverOptions, useMutation, useQuery } from 'react-query';

import getSyndicateRateL2, { GetSyndicateRateL2Input, GetSyndicateRateL2Output } from 'clients/api/queries/getSyndicateRateL2';
import { useUmiTokenContract, useUmiVaultContract, useVTokenContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';
import queryClient from 'clients/api/queryClient';


type Options = QueryObserverOptions<
    GetSyndicateRateL2Output,
    Error,
    GetSyndicateRateL2Output,
    GetSyndicateRateL2Output,
    [FunctionKey.GET_SYNDICATERATEL2, string]
>;

const useSyndicateRateL2 = (
    { accountAddress }: Omit<GetSyndicateRateL2Input, 'UmiVaultContract'>,
    options?: Options,
) => {
  const UmiVaultContract = useUmiVaultContract();
    return useQuery(
        [FunctionKey.GET_SYNDICATERATEL2, accountAddress],
        () =>
            getSyndicateRateL2({
                UmiVaultContract,
                accountAddress,
            }),
        options,
    );
};

export default useSyndicateRateL2;
